import { ALUMNIA_A_PATH, ALUMNIA_A_TRANSFORM, ALUMNIA_BLUE } from '@/lib/brand'

type LogoVariant = 'brand' | 'light' | 'dark'

const VARIANTS: Record<LogoVariant, { bg: string; fg: string }> = {
  /** Blue background, white "A" — primary brand mark */
  brand: { bg: ALUMNIA_BLUE, fg: 'white' },
  /** White background, blue "A" — for dark contexts (mobile nav, footer) */
  light: { bg: 'white', fg: ALUMNIA_BLUE },
  /** White background, near-black "A" — for neutral contexts */
  dark: { bg: 'white', fg: '#0f172a' },
}

interface AlumniaLogoProps {
  /** Size in pixels (width = height). Default: 32 */
  size?: number
  /** Color variant. Default: 'brand' */
  variant?: LogoVariant
  /** Additional CSS classes */
  className?: string
}

/**
 * Alumnia "A" logo rendered as an inline SVG.
 * Uses the Georgia Bold glyph path — no font dependency.
 */
export function AlumniaLogo({ size = 32, variant = 'brand', className }: AlumniaLogoProps) {
  const { bg, fg } = VARIANTS[variant]

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Alumnia"
      role="img"
    >
      <rect width="512" height="512" rx="80" fill={bg} />
      <g transform={ALUMNIA_A_TRANSFORM}>
        <path d={ALUMNIA_A_PATH} fill={fg} />
      </g>
    </svg>
  )
}
